<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2
          class="pl-2"
        >{{ editRoute ? $t('labels.edit_preventative_barrier') : $t('labels.add_preventative_barrier') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full p-0">
              <label>{{ $t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="preventative_barrier_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.preventative_barrier_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('preventative_barrier_name') }}</span>
            </div>
            <div class="vx-col sm: w-full p-0 mt-4">
              <label>{{ $t('labels.topevents')}}</label>
              <v-select
                multiple
                name="topevent"
                v-model="parent_id"
                :options="parentSection"
                :reduce="parentSection => parentSection.id"
                label="name"
                :closeOnSelect="false"
                class="mt-1"
              />
            </div>
          </div>
          <div class="mt-6 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-preventative-barrier"
              button="submit"
            >{{ editRoute ? $t('labels.update_preventative_barrier') : $t('labels.add_preventative_barrier') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      name: "",
      parentSection: [],
      parent_id: []
    };
  },
  components: {
    "v-select": vSelect
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getTopevents();
    this.setValidationMessage();
    if (this.editRoute) {
      this.getPreventativebarriers();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdatePreventativebarriers();
        }
      });
    },
    // API Integration for add-update designation
    async createUpdatePreventativebarriers() {
      let input = {
        name: this.name,
        top_event_ids: this.parent_id
      };
      let url = this.editRoute
        ? "/preventative-barriers/update/" + this.editRoute
        : "/preventative-barriers/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-preventative-barrier",
        true
      );
      if (response) {
        this.$router.push({ name: "Preventativebarriers" });
      }
    },
    async getPreventativebarriers() {
      let response = await this.getHTTPGetResponse(
        "/preventative-barriers/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let preventative_barrier = data.preventative_barrier;
        this.name = preventative_barrier.name;
        //this.parent_id = preventative_barrier.top_event_ids;
        let filteredSection = [];
        for (var i = 0; i < preventative_barrier.top_events.length; i++) {
          filteredSection.push(preventative_barrier.top_events[i].id);
        }
        this.parent_id = filteredSection;
      }
    },
    async getTopevents() {
      let input = {
        name: this.parent_id
      };
      let response = await this.getHTTPPostResponse("/top-events/list", input);
      if (response) {
        let top_events_req = response.data.top_events;
        let filteredSection = [];
        for (var i = 0; i < top_events_req.length; i++) {
          let obj = { id: top_events_req[i].id, name: top_events_req[i].name };
          filteredSection.push(obj);
        }
        this.parentSection = filteredSection;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>